import { Text } from 'tombac';
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SelectAllButton = _ref => {
  let {
    areAllSelected,
    onSelectAllClick,
    onDeselectAllClick
  } = _ref;
  return /*#__PURE__*/_jsxs(Text, {
    as: "button",
    onClick: e => {
      e.preventDefault();
      areAllSelected ? onDeselectAllClick() : onSelectAllClick();
    },
    size: "s",
    variant: "interactive",
    "data-sentry-element": "Text",
    "data-sentry-component": "SelectAllButton",
    "data-sentry-source-file": "SelectAllButton.tsx",
    children: [areAllSelected ? 'Deselect' : 'Select', " all"]
  });
};